import { Title, TitleProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { useBreakpoint } from 'shared/lib';

export type RegistryTitleProps = TitleProps;

export const createRegistryTitle = () => {
	const RegistryTitle = forwardRef<HTMLHeadingElement, RegistryTitleProps>(
		({ children, className, ...props }, ref) => {
			const md = useBreakpoint('md');

			return (
				<Title
					ref={ref}
					order={1}
					size={md ? 'h1' : 'h3'}
					className={clsx('registry-title', className)}
					{...props}
				>
					{children}
				</Title>
			);
		},
	);

	return RegistryTitle;
};
